export default "__VITE_ASSET__Bnb9uOLl__"